import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import {
  Chat,
  Channel,
  MessageList,
  Window,
  ChannelList,
  InfiniteScroll,
} from "stream-chat-react";
import useChatClient from "../StatesStore/ChatClient";
import "stream-chat-react/dist/css/v2/index.css";
import { UserAuth } from "../Context";
import { Card, Nav } from "react-bootstrap";
import { EmojiPicker } from "stream-chat-react/emojis";
import { encodeToMp3 } from "stream-chat-react/mp3-encoder";
import "./Chat.css";
import LoadingSpinner from "../UserProfile/LoadingSpinner";
import { ChannelHeader } from "./ChannelHeader";
import CustomMessageInput from "./CustomMessageInput";
import ProductsInChat from "./ProductsInChat";
import { getFilters } from "./lib.js/getFilters";
import useThemeState from "../StatesStore/Theme";
import CustomAttachment from "./CustomAttachment";
import { CustomAttachmentSelector } from "./CustomAttachmentSelector";
import useChatOpen from "../StatesStore/ChatOpen";
import useChatFilter from "../StatesStore/ChatFilter";
import ChatSearch from "./ChatSearch";

function ChatMobile() {
  const { user } = UserAuth();
  const { chatId, type } = useParams();
  const client = useChatClient((state) => state.client);
  const { isChatOpen, setIsChatOpen, isChannel, setIsChannel } = useChatOpen();
  const { chatFilterType } = useChatFilter();
  const { theme } = useThemeState();
  const [activeChannel, setActiveChannel] = useState(null);
  const [filters, setFilters] = useState(getFilters(chatFilterType, user));

  useEffect(() => {
    setFilters(getFilters(chatFilterType, user));
  }, [chatFilterType]);

  useEffect(() => {
    if (!client) return;

    const loadChannel = async () => {
      // Use the channel from useChatOpen if available
      if (isChannel) {
        setActiveChannel(isChannel);
        setIsChatOpen(true);
        return;
      }

      // Otherwise fall back to using chatId from params
      if (!chatId) return;

      const channel = client.channel(
        type === "user" ? "messaging" : "team",
        chatId
      );
      console.log("channel", channel);
      await channel.watch();
      setActiveChannel(channel);
      setIsChatOpen(true);
    };

    loadChannel();
    return () => setIsChatOpen(false);
  }, [client, chatId, isChannel]);

  const sort = [{ pinned_at: -1 }, { last_message_at: -1 }, { updated_at: -1 }];

  const options = {
    state: true,
    presence: true,
    // limit: 10,
  };

  if (!client) {
    return (
      <div className="w-100">
        <LoadingSpinner />
      </div>
    );
  }
  if (!user) return;
  return (
    <>
      <style>
        {`
        .str-chat {
          --str-chat__border-radius-circle: 4px; 
          --str-chat__avatar-background-color: #dddddd;
          --str-chat__avatar-color:#222222;
           --str-chat__channel-preview-active-background-color: transparent !important;
        }
           .str-chat__load-more-button > button {
            width: 96.5vw !important;
          }
       
        .str-chat__channel-preview-messenger--last-message {
            width: 76vw !important;
          }
        .str-chat__channel-preview-messenger--name {
            width: 66vw !important;
          }
           
      `}
      </style>
      <Chat
        client={client}
        customClasses={{
          channelList: `str-chat__theme-${theme} str-chat__channel-list`,
          channel: `str-chat__theme-${theme} str-chat__channel`,
        }}
      >
        {!isChatOpen ? (
          <>
            <ChatSearch setFilters={setFilters} />
            <Card
              className="w-100 rounded-0 p-0 pb-2 pt-0 mt-0 border-0"
              style={{ height: "100vh" }}
            >
              <Card.Body
                className="rounded-0 p-0 h-100"
                onClick={() => setIsChatOpen(true)}
              >
                <Nav
                  className="d-flex flex-column nav-pills nav-pills-soft gap-4"
                  style={{ paddingBottom: "58px" }}
                  onClick={() => {
                    // setLoadedFirstTime(false);
                    setActiveChannel(null);
                    setIsChannel(null);
                  }}
                >
                  <ChannelList
                    filters={filters}
                    sort={sort}
                    options={options}
                    customActiveChannel={chatId}
                    Paginator={InfiniteScroll}
                  />
                </Nav>
              </Card.Body>
            </Card>
          </>
        ) : (
          <div className="w-100">
            <Channel
              channel={activeChannel}
              EmojiPicker={EmojiPicker}
              Attachment={CustomAttachment}
              AttachmentSelector={CustomAttachmentSelector}
            >
              <Window>
                <div
                  className="bg-mode"
                  style={{ position: "sticky", top: "0", zIndex: "10" }}
                >
                  <ChannelHeader setIsChatOpen={setIsChatOpen} />
                  <ProductsInChat />
                </div>
                <div style={{ minHeight: document.body.offsetHeight - 113 }}>
                  <MessageList
                    messageActions={["edit", "delete", "quote", "react"]}
                    closeReactionSelectorOnClick={true}
                    additionalMessageInputProps={{
                      urlEnrichmentConfig: { enrichURLForPreview: true },
                    }}
                  />
                </div>
                <style jsx>
                  {`
                    .str-chat__dialog-overlay {
                      position: inherit !important;
                    }
                  `}
                </style>
                <div
                  style={{
                    position: "fixed",
                    bottom: 0,
                    zIndex: 12,
                    width: "100%",
                  }}
                >
                  <CustomMessageInput
                    audioRecordingConfig={{
                      transcoderConfig: { encoder: encodeToMp3 },
                    }}
                    audioRecordingEnabled
                    urlEnrichmentConfig={{ enrichURLForPreview: true }}
                  />
                </div>
              </Window>
            </Channel>
          </div>
        )}
      </Chat>
    </>
  );
}

export default ChatMobile;
